import { IconButton, Menu, MenuItem, SvgIconTypeMap, useTheme } from "@mui/material";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { useState } from "react";
import { tokens } from "theme";

export type MenuButtonProps = {
    icon: OverridableComponent<SvgIconTypeMap<{}, "svg">> & { muiName: string; };
    items: string[];
    onMenuItemClick: (link: string) => void;
}

export default function MenuButton(props: MenuButtonProps) {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const Wrapper = props.icon;
    const listItems = props.items.map((link) =>
        <MenuItem key={link} onClick={() => handleItemClick(link)}>{link}</MenuItem>
    );

    const handleMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    // Dismissal only closes the menu. Kept separate from selection because MUI calls
    // onClose with a reason string ('escapeKeyDown', 'backdropClick', ...); sharing one
    // handler passed that reason on as though it were the chosen item, so
    // onMenuItemClick fired on every dismissal with nothing actually selected.
    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleItemClick = (link: string) => {
        setAnchorEl(null);
        props.onMenuItemClick(link);
    };

    return (
        <>
            <IconButton onClick={handleMenu} sx={{ color: '#FFF' }}>
                {<Wrapper />}
            </IconButton>
            <Menu
                sx={{ "& .MuiPaper-root": { backgroundColor: colors.primary[400] } }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                {listItems}
            </Menu>
        </>
    )
}